const bgImageHero = {
  title: 'text-white',
  root: ' bg-black bg-cover bg-center relative before:absolute before:inset-0 before:bg-black before:opacity-30 before:z-0',
  wrapper: 'relative z-10',
}

export { bgImageHero }
